import axios from 'axios';
import JWTService from './JWTService';

class ApiService {
  constructor(baseURL) {
    this.cacheStorage = {};
    this.tokenInterceptor = null;
    this.refreshTokenInterceptor = null;
    this.axios = axios.create({
      baseURL,
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json;charset=UTF-8' },
    });
  }

  /*
   * Достает из кеша response по url,
   * если такой не найден, делает get запрос и добавляет в кеш
   *
   * @return Promise<response>
   */
  getCached(resource, params) {
    const value = this.cacheStorage[resource];
    if (value) return value;

    this.cacheStorage[resource] = this.get(resource, params);
    return this.cacheStorage[resource];
  }

  get(resource, params) {
    return this.axios.get(`${resource}`, { params });
  }

  post(resource, params, headers) {
    return this.axios.post(`${resource}`, params, headers);
  }

  put(resource, params) {
    return this.axios.put(`${resource}`, params);
  }

  delete(resource, params) {
    return this.axios.delete(resource, params);
  }

  mountAuthInterceptors() {
    this.tokenInterceptor = this.axios.interceptors.request.use((config) => {
      const token = JWTService.getToken();
      config.headers.Authorization = token ? `Bearer ${token}` : 'sdfsaf';
      return config;
    });
  }

  unmountAuthInterceptors() {
    this.axios.interceptors.request.eject(this.tokenInterceptor);
    this.axios.interceptors.response.eject(this.refreshTokenInterceptor);
  }
}

export const apiService = new ApiService(process.env.VUE_APP_API_URL);
